import Lexicon from "./Lexicon";

export default class LexiconStore {

    private lexicons: Map<string, Lexicon>;

    public constructor(lexicons: Lexicon[]) {
        this.lexicons = new Map(lexicons.map(lexicon =>
            [lexicon.getId(), lexicon] as [string, Lexicon]));
    }

    public getLexicon(id: string): Lexicon {
        const lexicon = this.lexicons.get(id);
        if (lexicon === undefined) {
            throw new Error('Lexicon not found: ' + id);
        }
        return lexicon;
    }
}
